"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BankRoutes = void 0;
var BankRoutes;
(function (BankRoutes) {
    BankRoutes["BasePrefix"] = "banks";
    BankRoutes["ById"] = ":bankId";
    BankRoutes["All"] = "all";
    BankRoutes["List"] = "list";
})(BankRoutes = exports.BankRoutes || (exports.BankRoutes = {}));
